/* eslint-disable import/no-anonymous-default-export */
export default {
  // Ver quais sao as URL's certas para colocar os endpoints corretos
  meEndpoint: '/user/me',
  loginEndpoint: '/user/login',
  loginGoogleEndpoint: '/user/login/sso/google',
  loginDiscordEndpoint: '/user/login/sso/discord',
  socialAccountsEndpoint: '/user/social-accounts',
  logoutEndpoint: '/user/logout',
  registerEndpoint: '/user',
  registerTrialEndpoint: '/user/trial',
  onTokenExpiration: 'logout',
  cookieName: '',
};
